import { isDef as i, isNumeric as n } from "./validate.js";
function p(o) {
  if (i(o))
    return n(o) ? `${o}px` : String(o);
}
const r = (o) => o.stopPropagation();
function a(o, t) {
  (typeof o.cancelable != "boolean" || o.cancelable) && o.preventDefault(), t && r(o);
}
export {
  p as addUnit,
  a as preventDefault,
  r as stopPropagation
};
